import type { RouteRecordRaw } from 'vue-router'
import MzRouterView from '@meizhen/shared/src/components/MzRouterView.vue'

export const initialRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: async () => import('@/views/login/Index.vue'),
  },
  {
    path: '/denied',
    name: '403',
    component: async () => import('@/views/403.vue'),
  },
  {
    path: '/',
    name: 'Root',
    component: async () => import('@/views/layout/Index.vue'),
    meta: {
      menu: true,
      showInBreadcrumb: false,
    },
    beforeEnter: (to) => {
      if (to.name !== 'Root') return

      const { firstPermissedRoute } = useProfileStore()
      const r = firstPermissedRoute(useRouter()) || { name: 'Cinema' }

      return r
    },
    children: [
      {
        path: 'cinema',
        name: 'Cinema',
        component: async () => import('@/views/cinema/Index.vue'),
        meta: {
          title: '影院管理',
          showInSide: true,
          showInBreadcrumb: true,
          permissions: 'cinema:list',
        },
      },
      {
        path: 'cinema/group',
        name: 'CinemaGroup',
        component: async () => MzRouterView,
        redirect: { name: 'CinemaGroupIndex' },
        meta: {
          title: '影院联盟',
          showInSide: true,
          showInBreadcrumb: true,
          permissions: 'cinemaGroup:list',
        },
        children: [
          {
            path: '',
            name: 'CinemaGroupIndex',
            component: async () => import('@/views/group/Index.vue'),
          },
          {
            path: 'create',
            name: 'CreateCinemaGroup',
            component: async () => import('@/views/group/CreateGroup.vue'),
            meta: {
              title: '创建',
              showInSide: false,
              showInBreadcrumb: true,
              permissions: 'cinemaGroup:update',
            },
          },
          {
            path: 'edit/:id',
            name: 'EditCinemaGroup',
            component: async () => import('@/views/group/CreateGroup.vue'),
            meta: {
              title: '编辑',
              showInSide: false,
              showInBreadcrumb: true,
              permissions: 'cinemaGroup:update',
            },
          },
        ],
      },

      {
        path: 'order',
        name: 'Order',
        component: MzRouterView,
        redirect: { name: 'TicketOrderIndex' },
        meta: {
          title: '影票订单',
          showInSide: true,
          showInBreadcrumb: true,
          permissions: 'ticketTrade:list',
        },
        children: [
          {
            path: '',
            name: 'TicketOrderIndex',
            component: async () => import('@/views/order/ticket/Index.vue'),
          },
          {
            path: 'export/:tp',
            name: 'ticketExport',
            component: async () => import('@/views/export/Index.vue'),
            meta: {
              title: '导出任务',
              showInSide: false,
              showInBreadcrumb: true,
              permissions: 'ticketTrade:export',
            },
          },
        ],
      },
      {
        path: 'version',
        name: 'Version',
        component: async () => MzRouterView,
        redirect: { name: 'VersionIndex' },
        meta: {
          title: '版本控制',
          showInSide: true,
          showInBreadcrumb: true,
          permissions: 'version:list',
        },
        children: [
          {
            path: '',
            name: 'VersionIndex',
            component: async () => import('@/views/version/Index.vue'),
          },
          {
            path: 'template',
            name: 'TemplateIndex',
            component: async () => import('@/views/version/template/Index.vue'),
            meta: {
              title: '微信小程序模板库',
              showInSide: false,
              showInBreadcrumb: true,
            },
          },
          {
            path: 'audit/list',
            name: 'AuditList',
            component: async () => import('@/views/version/audit/Index.vue'),
            meta: {
              title: '微信审核列表',
              showInSide: false,
              showInBreadcrumb: true,
            },
          },
        ],
      },
      {
        path: 'permission',
        name: 'Permission',
        component: async () => MzRouterView,
        meta: {
          title: '权限管理',
          showInSide: true,
          showInBreadcrumb: true,
        },
        children: [
          {
            path: '',
            name: 'PermissionIndex',
            component: async () => import('@/views/permission/Index.vue'),
            meta: {
              title: '权限',
              showInSide: true,
              showInBreadcrumb: false,
              permissions: 'permission:list',
            },
          },
          {
            path: 'menu',
            name: 'Menu',
            component: async () => import('@/views/permission/Menu.vue'),
            meta: {
              title: '菜单',
              showInSide: true,
              showInBreadcrumb: true,
              permissions: 'menu:list',
            },
          },
        ],
      },

      {
        path: 'account',
        component: MzRouterView,
        meta: {
          title: '账号管理',
          showInSide: true,
          showInBreadcrumb: false,
          onlySupper: true,
        },
        children: [
          {
            path: '',
            name: 'Account',
            component: async () => import('@/views/admin/account/Index.vue'),
            meta: {
              title: '管理员',
              showInSide: true,
              showInBreadcrumb: true,
              onlySupper: true,
              permissions: 'admin:list',
            },
          },
          {
            path: 'role',
            name: 'Role',
            component: async () => import('@/views/admin/role/Index.vue'),
            meta: {
              title: '角色管理',
              showInSide: true,
              showInBreadcrumb: true,
              onlySupper: true,
              permissions: 'role:list',
            },
          },
        ],
      },
    ],
  },
]
